import React, { useMemo } from "react";
// REDUX
import { useSelector } from "react-redux";
// CUSTOM HOOKS
import { useLastLiftMessage } from "../socketMessageState/BankMessagesContext";
// ICONS DARK DOWN SEQUENCE
import downDark from "../../../assets/icons/escalator/es-dark-down.gif";
// ICONS DARK UP SEQUENCE
import upDark from "../../../assets/icons/escalator/es-dark-up.gif";
// ICONS LIGHT DOWN SEQUENCE
import downLight from "../../../assets/icons/escalator/es-light-down.gif";
// ICONS LIGHT UP SEQUENCE
import upLight from "../../../assets/icons/escalator/es-light-up.gif";
// ICONS STATUS
import darkStopped from "../../../assets/icons/escalator/es-dark-stopped.svg";
import iconLightStopped from "../../../assets/icons/escalator/es-light-stopped.svg";
import darkIdle from "../../../assets/icons/escalator/es-dark-idle.svg";
import lightIdle from "../../../assets/icons/escalator/es-light-idle.svg";
// INTERFACES
import { RootState } from "../../../app/store";
import { LiftInterface } from "../../../interfaces/Lift.interface";
import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";
import { bitmaskPrefix } from "../../../utils/typedKeys";
import { stringToUuidT } from "../../../utils/uuid";
// CONSTANTS
import { BLANK_SOCKET_MESSAGE } from "../../../constants/monitoring";

function IconDefinitionEscalatorDefault({
  iconSize = 40,
  mapViewClass = "",
  lift,
}: {
  iconSize: number;
  mapViewClass: string;
  lift: LiftInterface;
}) {
  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const liftUuid = useMemo(() => stringToUuidT(lift.id), [lift.id]);
  const socketMessageLift: SocketMessageInterface =
    useLastLiftMessage(liftUuid) || BLANK_SOCKET_MESSAGE;

  const directionState = useMemo<"UP" | "DOWN" | "STOP" | "IDLE">(() => {
    const prefix = bitmaskPrefix(socketMessageLift.bankId, socketMessageLift.liftId);
    const upKey = `${prefix}Usage:Up`;
    const downKey = `${prefix}Usage:Down`;
    const hasUsageDirectionData = upKey in socketMessageLift.bitmask || downKey in socketMessageLift.bitmask;

    if (!hasUsageDirectionData) return "IDLE";

    const up = socketMessageLift.bitmask[upKey] ?? false;
    const down = socketMessageLift.bitmask[downKey] ?? false;

    if (up && !down) return "UP";
    if (down && !up) return "DOWN";
    return "STOP";
  }, [socketMessageLift.bankId, socketMessageLift.liftId, socketMessageLift.bitmask]);

  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div
      className={`${mapViewClass || "monitoringView__controlPanelActionIcon__escalator"
        }`}
    >
      {directionState === "IDLE" && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={darkIdle} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={lightIdle} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
      {directionState === "STOP" && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={darkStopped} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img
              src={iconLightStopped}
              alt=""
              height={iconSize}
              width={iconSize}
            />
          )}
        </div>
      )}
      {directionState === "UP" && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={upDark} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={upLight} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
      {directionState === "DOWN" && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={downDark} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={downLight} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
    </div>
  );
}

export default React.memo(IconDefinitionEscalatorDefault);
